/**
 * テレメトリを起動するかの判断（docs/spec/observability.md §11）。DOM に触れない純粋関数。
 */

export const PRODUCTION_ORIGIN = 'https://class.inductor.dev';
export const STORAGE_KEY = 'class.telemetry';

export interface TelemetryEnv {
  /** `import.meta.env.PROD` */
  prod: boolean;
  /** `import.meta.env.DEV` */
  dev: boolean;
  /** `location.origin` */
  origin: string;
  /** `import.meta.env.VITE_TELEMETRY`（'on' / 'off' / 未設定） */
  viteTelemetry: string | undefined;
  /** `localStorage.getItem('class.telemetry')`（'on' / 'off' / null） */
  storageFlag: string | null;
}

export type Decision =
  | { enabled: true; reason: 'production' | 'forced' | 'env-on' | 'storage-on' }
  | { enabled: false; reason: 'env-off' | 'storage-off' | 'dev' | 'not-production' };

/**
 * 優先順位: 'off'（環境変数・localStorage）> 'on' / force > dev > 本番ホスト判定。
 */
export function decideTelemetry(env: TelemetryEnv, force = false): Decision {
  if (env.viteTelemetry === 'off') return { enabled: false, reason: 'env-off' };
  if (env.storageFlag === 'off') return { enabled: false, reason: 'storage-off' };
  if (force) return { enabled: true, reason: 'forced' };
  if (env.viteTelemetry === 'on') return { enabled: true, reason: 'env-on' };
  if (env.storageFlag === 'on') return { enabled: true, reason: 'storage-on' };
  if (env.dev) return { enabled: false, reason: 'dev' };
  if (env.prod && env.origin === PRODUCTION_ORIGIN) return { enabled: true, reason: 'production' };
  return { enabled: false, reason: 'not-production' };
}

export function environmentName(env: Pick<TelemetryEnv, 'origin' | 'dev'>): string {
  if (env.origin === PRODUCTION_ORIGIN) return 'production';
  return env.dev ? 'development' : 'staging';
}
